// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"093379d5d97951ceb198","147":"393bc9806dc38d60b7e1","251":"0acb2acc572bba3d4a3a","352":"c909633e6d623609ae66","544":"da2e9679d2efe0ea37eb"}[chunkId] + ".js";
};